import Button from '@seaweb/coral/components/Button';
import { FormActionsWrapper } from 'pages/contact';
import { useLocaleContext } from 'providers/LocaleProvider';
import React from 'react';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  width: 160px;
  height: 42px;
  border-radius: 25px;
  background-image: linear-gradient(to bottom, #3ac4fb -34%, #1b92f5 107%);
`;

function ContactSubmitButton(props) {
  const { locale: t } = useLocaleContext();

  return (
    <FormActionsWrapper>
      <StyledButton {...props}>{t('hc.contact.submit')}</StyledButton>
    </FormActionsWrapper>
  );
}

export default ContactSubmitButton;
